import { useState, useEffect, useRef } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import { categoriesPerPage, menuPerPage } from '../../constants/constants'
import { getCategories, getCurrentCategory } from '../../redux/actions/categoriesAction'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useLocation, useParams } from 'react-router-dom'
import { CategoriesType, MenuType, ProductType } from '../../redux/actions/types'

import styles from './collectOrdersPage.module.css'

import { getAllMenu, getCurrentMenu, getMenuFromCompany } from '../../redux/actions/menuAction'
import DishesCardToOrder from '../../components/DishesCardToOrder/dishesCardToOrder'
import { getCurrentOrder } from '../../redux/actions/ordersAction'
import { getCurrentClaim } from '../../redux/actions/claimsAction'
import OrderedDishesListCard from '../../components/OrderedDishesListCard/OrderedDishesListCard'
import LeftArrow from '../../assets/icons/arrowLeft.svg'
import Select from 'react-select'
import { useMediaQuery } from 'react-responsive'

interface MenuCategory {
  category: {
    id: number
    name: string
    description: string
    products: ProductType[]
  }
}

const CollectOrdersPage = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const { id } = useParams()
  const [activeOption, setActiveOption] = useState<{ title: string; subTitle: string; id: number }>(
    {
      title: '',
      subTitle: '',
      id: -1,
    },
  )

  const [currentPage, setCurrentPage] = useState(1)
  const [selected, setSelected] = useState<any[]>([])
  const [catSubmited, setCatSubmited] = useState(false)
  const previousCategory = useRef<number | null>(null)
  const { category, currentCategory } = useAppSelector((state) => state.categories)
  const { menu } = useAppSelector((state) => state.menu)

  const { token, userRole } = useAppSelector((state) => state.auth)
  const { currentClaim } = useAppSelector((state) => state.claims)
  const [filteredDishes, setFilteredDishes] = useState<any[]>([])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const claimId = searchParams.get('id') // Extract 'id' from the query string

    if (claimId) {
      dispatch(getCurrentClaim({ claimId, token }))
    }
  }, [location, dispatch, token])

  const goBack = () => {
    window.history.back()
  }
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  useEffect(() => {
    if (currentClaim.order != null || undefined) {
      dispatch(getCurrentOrder({ token, currentPlace: currentClaim.order.id }))
    }
  }, [dispatch, token, currentClaim])

  const [selectedMenu, setSelectedMenu] = useState<{
    title: string
    description: string
    id: string
    categoryIds: string[]
    menuCategories: string[]
  }>({
    title: '',
    description: '',
    id: '',
    categoryIds: [],
    menuCategories: [],
  })

  const activeItem = async (item: { id: number; title: string; subTitle: string }) => {
    setActiveOption({
      title: item.title,
      subTitle: item.subTitle,
      id: item.id,
    })

    await _getCurrentCategory(item.id)
  }

  const _getCurrentCategory = async (id: number) => {
    if (id == currentCategory.id) return
    await dispatch(getCurrentCategory({ categoryId: String(id), token }))
  }

  const dummyData = (array: CategoriesType[]) => {
    const items: any[] = array.map((category) => {
      return {
        id: category.id,
        title: category.name,
        subTitle: category.description,
        products: category.products,
      }
    })
    return items
  }

  const eventList = dummyData(category.category)

  useEffect(() => {
    if (location.state) {
      dispatch(
        getCategories({
          token,
          page: currentPage,
          itemsPerPage: categoriesPerPage,
          name: location.state.name,
          menuId: selectedMenu.id,
        }),
      )
    } else {
      {
        dispatch(
          getCategories({
            token,
            page: currentPage,
            itemsPerPage: categoriesPerPage,
            menuId: selectedMenu.id,
          }),
        )
      }
    }
  }, [dispatch, currentPage, setCurrentPage, categoriesPerPage, catSubmited])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const categoryId = searchParams.get('category')

    if (categoryId && Number(categoryId) !== previousCategory.current) {
      const category = eventList.find((item) => item.id === Number(categoryId))
      if (category) {
        setActiveOption({
          title: category.title,
          subTitle: category.subTitle,
          id: category.id,
        })
        if (category.id == currentCategory.id) return
        _getCurrentCategory(category.id)
        previousCategory.current = Number(categoryId) // Store last fetched category
      }
    }
  }, [location.search, eventList])

  const dummyDataMenu = (array: MenuType[]) => {
    const items: any[] = array.map((menu) => {
      return {
        id: menu.id,
        title: menu.name,
        description: menu.description,
        categoryIds: menu.categoryIds,
        menuCategories: menu.menuCategories,
      }
    })
    return items
  }

  useEffect(() => {
    if (currentClaim?.order?.orderDetails) {
      const newFilteredDishes = currentClaim.order.orderDetails.map((detail) => ({
        id: detail.productId,
        name: detail.name,
        price: detail.price,
        quantity: detail.quantity,
        images: detail.images,
        comment: detail.comment,
        description: '',
        weight: '',
        measurement: '',
        createdAt: '',
      }))

      if (JSON.stringify(newFilteredDishes) !== JSON.stringify(filteredDishes)) {
        setFilteredDishes(newFilteredDishes)
      }
    }
  }, [currentClaim, filteredDishes])

  const handleSelectChange = async (e: any) => {
    dispatch(
      getAllMenu({
        token,
        page: currentPage,
        itemsPerPage: menuPerPage,
        name: location.state,
      }),
    )
    const selectedMenuId = e.target.value
    const menuItem = menuList.find((item) => item.id === parseInt(selectedMenuId))

    if (menuItem) {
      await dispatch(getCurrentMenu({ menuId: String(menuItem.id), token }))
      setSelectedMenu(menuItem)
      setSelected([menuItem])
    } else {
      setSelectedMenu({
        title: '',
        description: '',
        id: '',
        categoryIds: [],
        menuCategories: [],
      })
    }
  }

  useEffect(() => {
    if (catSubmited) {
      dispatch(
        getCategories({
          token,
          page: currentPage,
          itemsPerPage: categoriesPerPage,
          menuId: selectedMenu.id,
        }),
      )
      setCatSubmited(false)
    }
  }, [catSubmited, dispatch, currentPage, token])
  useEffect(() => {
    if (location) {
      dispatch(
        getAllMenu({
          token,
          page: currentPage,
          itemsPerPage: menuPerPage,
          name: location.state,
        }),
      )
    } else {
      if (
        userRole === 'directorPlace' ||
        userRole === 'employeePlace' ||
        userRole === 'directorAgent'
      ) {
        dispatch(
          getMenuFromCompany({
            token,
            page: currentPage,
            itemsPerPage: menuPerPage,
          }),
        )
      } else {
        dispatch(
          getCategories({
            token,
            page: currentPage,
            itemsPerPage: menuPerPage,
            menuId: selectedMenu.id,
          }),
        )
      }
    }
  }, [dispatch, currentPage, setCurrentPage, menuPerPage])

  const menuList = dummyDataMenu(menu.menu)
  useEffect(() => {
    if (id && !selectedMenu.id) {
      const selectedMenuFromList = menuList.find((item) => item.id === parseInt(id))

      if (selectedMenuFromList) {
        setSelectedMenu(selectedMenuFromList)
        setSelected([selectedMenuFromList])
      } else {
        dispatch(getCurrentMenu({ menuId: id, token }))
      }
    }
  }, [id, menuList, selectedMenu.id, token, dispatch])

  return (
    <div className={styles.mainPage}>
      <Navbar />
      <div className={styles.menuTitleBlock}>
        <div className={styles.menuSelectBlock}>
          <div className={styles.titleBlock}>
            <div className={styles.topTitle}>
              <button className={styles.goBackButton} onClick={() => goBack()}>
                <img src={LeftArrow} alt='' />
              </button>

              <h2>Мой Заказ</h2>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.menuSelectContainer}>
        <Select
          options={[
            ...menuList.map((item) => ({
              value: item.id,
              label: item.title,
            })),
          ]}
          value={
            selectedMenu.id
              ? {
                  value: selectedMenu.id,
                  label: menuList.find((item) => item.id === selectedMenu.id)?.title || '',
                }
              : null
          }
          onChange={(selectedOption) => {
            const newValue = selectedOption ? selectedOption.value : ''
            handleSelectChange({
              target: { value: newValue },
            } as React.ChangeEvent<HTMLSelectElement>)
          }}
          className={styles.selectInput}
          classNamePrefix='react-select'
          isClearable={true}
          placeholder='Выбрать меню'
          noOptionsMessage={() => 'Нет доступных меню'}
          styles={{
            control: (provided) => ({
              ...provided,
              border: 'none',
              boxShadow: 'none',
              minHeight: 'auto',
              backgroundColor: 'transparent',
            }),
            menu: (provided) => ({
              ...provided,
              right: 0,
              overflow: 'auto',
              height: 'auto',
            }),
            input: (provided) => ({
              ...provided,
              margin: 0,
              padding: 0,
              height: isMobile ? 42 : 24,
            }),
            clearIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: 0,
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            indicatorSeparator: () => ({
              display: 'none',
            }),
          }}
        />
      </div>
      <div className={styles.menuPageMain}>
        <div className={styles.left}>
          <div className={styles.menuItems}>
            <div className={styles.categoryTitle}>Категории</div>
            <ul className={styles.ul}>
              {selectedMenu.id ? (
                selectedMenu?.menuCategories?.length > 0 ? (
                  selected
                    .filter((item) => item.menuCategories && item.menuCategories.length > 0)
                    .map((item) =>
                      item.menuCategories.map((menuCategory: MenuCategory) => {
                        if (menuCategory?.category) {
                          return (
                            <li
                              key={menuCategory.category.id}
                              onClick={() => {
                                activeItem({
                                  id: menuCategory.category.id,
                                  title: menuCategory.category.name,
                                  subTitle: String(menuCategory.category.description),
                                })
                                _getCurrentCategory(menuCategory.category.id)
                              }}
                              className={
                                activeOption.id === menuCategory.category.id ? styles.active : ''
                              }
                            >
                              {menuCategory.category.name}
                            </li>
                          )
                        }
                        return null
                      }),
                    )
                ) : (
                  <div style={{ width: '100%', textAlign: 'center', marginBottom: 50 }}>
                    Нет категорий
                  </div>
                )
              ) : (
                <></>
              )}
            </ul>
          </div>
        </div>

        <div className={styles.right} style={{ display: 'flex' }}>
          <div className={styles.dishes}>
            {activeOption.title && (
              <div className={styles.categoryContainer}>
                <div className={styles.companyTitle}>{activeOption.title}</div>
                <div className={styles.companySubtitle}>{activeOption.subTitle}</div>
              </div>
            )}
            <div className={styles.dishesMainBlock}>
              <div className={styles.dishesBlock}>
                {eventList
                  .filter((event) => event.title === activeOption.title)
                  .flatMap((event) =>
                    event.products.map((product: any) => {
                      return { ...product, categoryId: event.id, categoryName: event.title }
                    }),
                  ).length === 0 ? (
                  <div style={{ width: '100%', textAlign: 'center', padding: 24 }}>
                    Список продуктов пуст...
                  </div>
                ) : (
                  eventList
                    .filter((event) => event.title === activeOption.title)
                    .flatMap((event) =>
                      event.products.map((product: any) => {
                        return { ...product, categoryId: event.id, categoryName: event.title }
                      }),
                    )
                    .map((dish) => {
                      return (
                        <DishesCardToOrder
                          categoryName={dish.categoryName}
                          currentOrder={currentClaim?.order?.orderDetails?.find(
                            (item) => item.productId === dish.id,
                          )}
                          quantity={
                            currentClaim?.order?.orderDetails?.find(
                              (item) => item.productId === dish.id,
                            )?.quantity ?? 0
                          }
                          categoryId={dish.categoryId}
                          id={dish.id}
                          key={dish.id}
                          name={dish.name}
                          price={dish.price}
                          weight={dish.weight}
                          images={dish.images}
                          description={dish.description}
                          measurement={dish.measurement}
                          category={dish.category}
                        />
                      )
                    })
                )}
              </div>
              {filteredDishes.length >= 1 && (
                <OrderedDishesListCard dishesCollection={filteredDishes as any} />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  )
}

export default CollectOrdersPage
